export const ACQUISITION_SOURCE_VALUES = [
  "referral_code",
  "affiliate_code",
  "utm",
  "organic",
] as const;

export type AcquisitionSource = (typeof ACQUISITION_SOURCE_VALUES)[number];

export type AcquisitionSourceFilter = {
  source?: AcquisitionSource[];
};

export const buildAcquisitionAnalyticsParams = ({
  start_date,
  end_date,
  source = [],
}: {
  start_date: string;
  end_date: string;
  source?: AcquisitionSource[];
}): URLSearchParams => {
  const params = new URLSearchParams({
    start_date,
    end_date,
  });
  source.forEach((value) => params.append("source[in]", value));
  return params;
};
